import React, { useEffect, useState } from "react";
import { NGROK } from "../../../APIs";
import axios from "axios";
import { myLocalStorage } from "../../../components/StorageHelper";
import useUserStore from "../../../services/userStore";
import K8Roles from "../Azure/Components/K8Roles";
import GCPGenericRoles from "./Components/GCPGenericRoles";
import useCloudSyncStore from "../../../services/useCloudSyncStore";
import { triggerCloudSync } from "../../../triggerCloudSync";
import CloudFilters from "../../../components/v2components/CloudFilters";
import CloudRoleSelectorBar from "../CloudRoleSelectorBar";
import "../../../components/v2components/Cloud/CloudStatus.css";
import EmptyStateCard from "../../../components/v2components/EmptyStateCard";
import { Cloud } from "lucide-react";

const GcpRoles = () => {
  const [tabValue, setTabValue] = useState("Roles");
  const [roleFilter, setRoleFilter] = useState("all");

  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;
  const [selectedTenantName, setSelectedTenantName] = useState(null);
  const [tenantList, setTenantList] = useState([]);
  const [projectIdList, setProjectIdList] = useState([]);

  const [projectId, setProjectId] = useState(null);

  const syncStatus = useCloudSyncStore((state) => state.syncStatus);

  const userData = useUserStore((state) => state.user);

  const ondemandButton = async () => {
    if (!projectId) return;

    try {
      const data = await triggerCloudSync(
        "gcp",
        "/api/gcp-sync/manual",
        selectedTenantName,
      );
      console.log("GCP Sync complete:", data);
    } catch (error) {
      console.error("GCP Sync failed", error);
    }
  };
  const handleTenantChange = (value) => {
    const tenant = tenantList.find((tenant) => tenant.tenantName === value);
    setSelectedTenantName(value);
    if (tenant !== undefined) myLocalStorage.setItem("latestTenant", tenant);
  };
  const handleProject = (value) => {
    if (!value) {
      setProjectId(null);
      myLocalStorage.setItem("gcpSelectedProjectId", "");
      return;
    }
    const project = projectIdList.find((project) => project === value);
    if (project !== undefined) {
      setProjectId(project);
      myLocalStorage.setItem("gcpSelectedProjectId", project);
    }
  };

  const fetchProjectIdList = async () => {
    const response = await axios.get(
      `${NGROK}/api/gcp/auth/fetchAllProjectIds`,
      {
        params: {
          tenantName: latestTenant,
        },
      },
    );
    const projects = Array.isArray(response.data) ? response.data : [];
    setProjectIdList(projects);
    if (projects.length === 0) {
      setProjectId(null);
      myLocalStorage.setItem("gcpSelectedProjectId", "");
    }
  };

  useEffect(() => {
    if (projectIdList.length === 1) return setProjectId(projectIdList[0]);

    if (projectIdList?.length > 1) {
      const latestprojectId = myLocalStorage.getItem("gcpSelectedProjectId");

      const project = projectIdList.find(
        (project) => project === latestprojectId,
      );
      if (project) setProjectId(project);
      else setProjectId(projectIdList[0]);
    }
  }, [projectIdList]);

  useEffect(() => {
    if (tenantList.length === 1)
      return setSelectedTenantName(tenantList[0].tenantName);

    if (tenantList?.length > 1) {
      const latestTenantName =
        myLocalStorage.getItem("latestTenant")?.tenantName;

      const tenant = tenantList.find(
        (tenant) => tenant.tenantName === latestTenantName,
      );
      if (tenant) setSelectedTenantName(tenant.tenantName);
      else setSelectedTenantName(tenantList[0].tenantName);
    }
  }, [tenantList]);

  useEffect(() => {
    const fetchTenants = async () => {
      const response = await axios.get(`${NGROK}/api/get-all-domains`);
      setTenantList(response.data);
    };
    fetchTenants();
  }, [userData]);

  useEffect(() => {
    fetchProjectIdList();
  }, [latestTenant]);

  return (
    <div className="h-full flex flex-col bg-background">
      <div className="flex flex-1 min-h-0 flex-col overflow-hidden p-6">
        <CloudFilters
          cloudProvider="gcp"
          onTenantChange={handleTenantChange}
          onCloudAccountChange={handleProject}
          isAdmin={true}
          onSync={ondemandButton}
          syncDisabled={!projectId || syncStatus["gcp"]}
          syncLoading={Boolean(projectId) && syncStatus["gcp"]}
        />

        {!projectId ? (
          <EmptyStateCard
            icon={Cloud}
            title="No GCP project configured"
            description="Configure a GCP project for this tenant to view GCP roles."
          />
        ) : (
          <>
            <CloudRoleSelectorBar
              roleFilter={roleFilter}
              onRoleFilterChange={setRoleFilter}
              activeTab={tabValue}
              onTabChange={setTabValue}
              cloudProvider="gcp"
            />

            {tabValue === "Roles" && (
              <GCPGenericRoles latestTenant={latestTenant} projectId={projectId} roleFilter={roleFilter} />
            )}
            {tabValue === "K8" && (
              <K8Roles
                selectedTenantName={selectedTenantName}
                allapi={`/api/gcp/kubernetes-clusters?tenantName=${selectedTenantName}&projectId=${projectId}`}
                rolesApi="/api/k8-resources/v1/roles/byClusterId"
                rolespoliciesApi="/api/k8-resources/v1/rolePolicies/byRoleUid"
                cloud="GCP"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default GcpRoles;
